import { normalizePosition } from "./helpers";

const POS_STYLE = {
  SB:    "bg-[#4b4b7d] text-[#d9d9ff]",
  BB:    "bg-[#4b4b7d] text-[#d9d9ff]",
  UTG:   "bg-[#444768] text-[#d6d8ef]",
  "UTG+1":"bg-[#444768] text-[#d6d8ef]",
  "UTG+2":"bg-[#444768] text-[#d6d8ef]",
  MP:    "bg-[#444768] text-[#d6d8ef]",
  LJ:    "bg-[#444768] text-[#d6d8ef]",
  HJ:    "bg-[#444768] text-[#d6d8ef]",
  CO:    "bg-[#444768] text-[#d6d8ef]",
  BTN:   "bg-[#4b4b7d] text-[#d9d9ff]",
  D:     "bg-[#4b4b7d] text-[#d9d9ff]",
};

export function PositionBadge({ position, className = "" }) {
  const pos = normalizePosition(position);
  const style = POS_STYLE[pos] || "bg-[#444768] text-[#d6d8ef]";
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full px-2 text-[10px] font-extrabold uppercase tabular-nums shadow-[inset_0_-1px_0_rgba(0,0,0,0.28)] ${style} ${className}`}
      style={{ width: 52, height: 18 }}
      data-testid={`position-badge-${pos}`}
    >
      {pos}
    </span>
  );
}
